export default __webpack_public_path__ + "static/media/DNC-1-400x482.2986c18a.png";